module.exports = __webpack_public_path__ + "img/close.91cf26b2.svg";